module.exports = __webpack_public_path__ + "static/media/360-degrees.5c8692fe.png";